export class LevelClient {
  db;

  constructor(db) {
    this.db = db;
    this.defaultConfig = {
      ttl: 60 * 1000 /* 1 min default ttl */,
    };
  }

  async get(key) {
    const cacheEntry = await this.db.get(key);

    if (undefined === cacheEntry) {
      return undefined;
    }

    const { expiresAt, value } = cacheEntry;

    if (expiresAt < Date.now()) {
      this.db.del(key);
      return undefined;
    }

    return value;
  }

  set(key, value, config = {}) {
    const localConfig = { ...this.defaultConfig, ...config };

    return this.db.put(key, { expiresAt: Date.now() + localConfig.ttl, value });
  }

  delete(key) {
    this.db.del(key);
  }

  clear() {
    this.db.clear();
  }
}
